<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-4" lang="en-GB">T<a id="_idTextAnchor005"></a>he Reckoning of Beauty</h1>
<p class="Verse-first" lang="en-GB">There was once a planet as green as can be –</p>
<p class="Verse-main" lang="en-GB">Trees stretched upwards towards their freedom and towards their clouds.</p>
<p class="Verse-main" lang="en-GB">Mountains stood steadily, looking out to</p>
<p class="Verse-main" lang="en-GB">Their surroundings of lush green fields of grass or to dense forests.</p>
<p class="Verse-main" lang="en-GB">They guarded their secrets within</p>
<p class="Verse-main" lang="en-GB">And protected the animals that dared to reach the top.</p>
<p class="Verse-main" lang="en-GB">Animals flew and ran living out little adventures.</p>
<p class="Verse-new" lang="en-GB">Until one day a new creature emerged</p>
<p class="Verse-main" lang="en-GB">From the darkened depths of the earth.</p>
<p class="Verse-main" lang="en-GB">They treated the earth as if it did not birth them.</p>
<p class="Verse-main" lang="en-GB">Trees toppled down, away from their freedoms and clouds,</p>
<p class="Verse-main" lang="en-GB">Bringing down the little twig homes settled peacefully in them.</p>
<p class="Verse-main" lang="en-GB">The mountains a refuge for fleeing animals<br/>from the once wild and sacred forests.</p>
<p class="Verse-new" lang="en-GB">The years turned by and by and the skies turned grey with each;</p>
<p class="Verse-main" lang="en-GB">Polluted by man’s wishful thinking.</p>
<p class="Verse-main" lang="en-GB">The animals that could once run</p>
<p class="Verse-main" lang="en-GB">Through fields of grass and have their adventures</p>
<p class="Verse-main" lang="en-GB">Are now stumbling onto roads, mouths gaping and eyes wide</p>
<p class="Verse-main" lang="en-GB">As they battle their way across uncharted territory –</p>
<p class="Verse-new" lang="en-GB">But of course man made the world his territory.</p>
<p class="Verse-main" lang="en-GB">They left no leaf unturned.</p>
<p class="Verse-main" lang="en-GB">They forced out each and every secret the mountains held dearly.</p>
<p class="Verse-main" lang="en-GB">They took the world and made it their own, biassed towards their survival.</p>
<p class="Verse-new" lang="en-GB">Blinded by their greed they did not notice how with each decade</p>
<p class="Verse-main" lang="en-GB">The earth began to fight back.</p>
<p class="Verse-main" lang="en-GB">Great Neptune’s waters rose in walls of</p>
<p class="Verse-main" lang="en-GB">Blues and greens, stronger than their pretentious armies.</p>
<p class="Verse-main" lang="en-GB">Hephaestus and his lava erupted out</p>
<p class="Verse-main" lang="en-GB">In acts of balance and punishment, leaving the land scorched.</p>
<p class="Verse-new" lang="en-GB">Even then, despite their warnings of anguish and equilibrium,</p>
<p class="Verse-main" lang="en-GB">The selfish creatures still went on.</p>
<p class="Verse-main" lang="en-GB">Unchanging in their ways, too ignorant to their motherly home.</p>
<p class="Verse-main" lang="en-GB">That when their eyes were finally opened</p>
<p class="Verse-main" lang="en-GB">To the destruction they had caused…</p>
<p class="Verse-main" lang="en-GB">Mother nature took her rightful place.</p>
<p class="Verse-main" lang="en-GB">And restored balance to the once again green planet</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035801855_EPUB-8.vue?b1158d24